export enum EmailType {
  PROFESSIONAL = 'PROFESSIONAL',
  PRIVATE = 'PRIVATE'
}
